function externalLink(link: string) {
  const EXTERNAL_LINK_REGEXP = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g

  return EXTERNAL_LINK_REGEXP.test(link)
}

function checkCryptoNumeric(value: string) {
  const CRYPTO_NUMERIC_REGEXP = /^[+]?(\d+\.?\d{0,18})$/g

  return CRYPTO_NUMERIC_REGEXP.test(value)
}

export const validations = {
  externalLink,
  checkCryptoNumeric,
}
